import { Tabs } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import LicenseOrders from './license-orders';
import LicenseKeys from './license-keys';

const LicenseTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Определяем активную вкладку на основе текущего URL
  const getActiveKey = () => {
    if (location.pathname === '/licenses/orders') return 'orders';
    if (location.pathname === '/licenses/keys') return 'keys';
    return 'orders'; // по умолчанию
  };

  const handleTabChange = (key) => {
    if (key === 'orders') {
      navigate('/licenses/orders');
    } else if (key === 'keys') {
      navigate('/licenses/keys');
    }
  };

  const items = [
    {
      key: 'orders',
      label: 'Заказы',
      children: <LicenseOrders />,
    },
    {
      key: 'keys',
      label: 'Ключи',
      children: <LicenseKeys />,
    },
  ];

  return (
    <Tabs
      activeKey={getActiveKey()}
      onChange={handleTabChange}
      items={items}
      type="card"
    />
  );
};

export default LicenseTabs;
